import Vue from 'vue'
// import { Button } from 'element-ui'
// import Vue from 'vue'
import {
  Button, Container, Header, Main, Aside,
  Form, FormItem, Input, CheckboxGroup, Checkbox,
  Message, Link, Menu, MenuItem, Row, Col, Tag, Breadcrumb,
  BreadcrumbItem, Card, Table, TableColumn, Pagination, Dialog, Select,
  Option, Upload, DatePicker, Alert, Radio, MessageBox, Autocomplete, Descriptions, DescriptionsItem,
  Tabs, TabPane, Switch, Collapse, CollapseItem, Notification,
  Popover
} from 'element-ui'
Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Link)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tag)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(Upload)
Vue.use(DatePicker)
Vue.use(Alert)
Vue.use(Radio)
Vue.use(Autocomplete)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Switch)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Popover)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
